require.register("ffss/component/row/NewsList", function(exports, require, module){
  $0
  
});

